// removed by extract-text-webpack-plugin
module.exports = {"component":"kDEn6zbXokjLVYjZJxPoc"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/MainForm/mainForm.css
// module id = 1242
// module chunks = 2